<div class="schedule-navbar">
    <div>
        <button (click)="moveWeek(-7)" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content">
        <p class="large">Mijn planning - Week {{ beginDate | date: 'w' }}</p>
        <p class="small">{{ beginDate | date: 'd MMM' }} - {{ endDate | date: 'd MMM y' }}</p>
    </div>
    <div>
        <button (click)="moveWeek(7)" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="schedule">
    <div class="items">
        @if (realisations && aanAfwezigheid) {
            @if (environment.weekScheduleComponent === 'planning') {
                <app-week-schedule-planning
                    [beginDate]="beginDate"
                    [endDate]="endDate"
                    [maxDate]="maxDate"
                    [realisations]="realisations"
                    [aanAfwezigheid]="aanAfwezigheid" />
            } @else {
                <app-week-schedule-realisations
                    [beginDate]="beginDate"
                    [maxDate]="maxDate"
                    [sourceRealisations]="realisations"
                    [aanAfwezigheid]="aanAfwezigheid" />
            }
        }
    </div>
</div>

<div class="button-wrapper">
    <div class="container">
        <div class="buttons">
            @if ([Functionalities.HourCheck, Functionalities.HourTimeEdit] | hasFunctionality) {
                <button class="planning-button" mat-raised-button color="accent" routerLink="/check-hours">
                    Urencontrole
                </button>
            }
            <div class="settings-menu">
                <app-settings-menu [date]="beginDate"></app-settings-menu>
            </div>
            @if (Functionalities.Hours | hasFunctionality) {
                <button class="planning-button" mat-raised-button color="primary" routerLink="/hours">
                    Urenregistratie
                </button>
            }
        </div>
    </div>
</div>
